import { render } from "./index.vue?vue&type=template&id=b5da70aa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=b5da70aa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b5da70aa"

export default script